import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import 'reveal.js/dist/reveal.css';
import 'reveal.js/dist/theme/white.css';

export default function RevealDeck({ deck }) {
  const revealRootRef = useRef(null);
  const revealInstanceRef = useRef(null);

  useEffect(() => {
    let destroyed = false;
    (async () => {
      if (revealRootRef.current) {
        const Reveal = (await import('reveal.js')).default;

        // Detect mobile portrait mode
        const isMobilePortrait = window.innerWidth <= 768 && window.innerHeight > window.innerWidth;

        const instance = new Reveal(revealRootRef.current, {
          embedded: true,
          hash: true,
          slideNumber: true,
          transition: 'fade',
          // Use flexible dimensions for mobile portrait, fixed for desktop
          width: isMobilePortrait ? window.innerWidth : 1920,
          height: isMobilePortrait ? window.innerHeight : 1080,
          margin: isMobilePortrait ? 0.01 : 0.02,
          minScale: isMobilePortrait ? 0.5 : 0.2,
          maxScale: isMobilePortrait ? 1.0 : 2.0,
        });
        
        revealInstanceRef.current = instance;
        await instance.initialize();
        window.Reveal = instance;
      }
    })();
    return () => {
      if (revealInstanceRef.current && !destroyed) {
        try {
          revealInstanceRef.current.destroy();
        } catch {
          /* noop */
        }
      }
      destroyed = true;
    };
  }, [deck]);

  if (!deck) return null;

  const accent = deck?.accent_color;
  return (
    <div className="reveal h-screen" ref={revealRootRef}>
      <div className="slides">
        {deck.slides.map((s, i) => {
          const SlideComponent = s.component;
          const isBgImage =
            (s.slide_type === 'Cover')
            && s.image_url;
          const sectionProps = {
            'data-transition': 'fade',
            ...(isBgImage ? {
              'data-background-image': s.image_url,
              'data-background-size': 'cover',
              'data-background-position': 'center',
            } : {})
          };
          return (
            <section key={i} {...sectionProps}>
              {SlideComponent ? (
                <SlideComponent {...s} accent_color={accent} />
              ) : (
                <div className="p-10 text-red-500">Unknown slide type: {s.slide_type}</div>
              )}
            </section>
          );
        })}
      </div>
      <div className="reveal-footer pointer-events-auto">
        <a href="https://srx.co.id" target="_blank" rel="noopener noreferrer">Powered by SRX</a>
      </div>
    </div>
  );
}

RevealDeck.propTypes = { deck: PropTypes.object };